// import React, { useEffect, useRef, useState } from "react";
// import { AudioOverlay, BannerWrapper } from "./Styled";
// import { Col, Container, Row } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import {
//   Box,
//   HeadingStyled,
//   LazyImage,
//   TextStyled,
// } from "../../Styled/Elements";
// import { ContactButton } from "../../Styled/CustomElements";
// import { BannerBg, BannerBgAr, TutorialsVidAr, TutorialsVidEn } from "../../Styled/AllImages";
// import { scroller } from "react-scroll";
// import { toast } from "react-toastify";
// import { Link } from "react-router-dom";

// const Banner = () => {
//   const WEBSITE_URL = process.env.REACT_APP_WEBSITE_BASE_URL;
//   const videoRef = useRef(null);
//   const [hasUserInteracted, setHasUserInteracted] = useState(false);
//   const [isVideoPlaying, setIsVideoPlaying] = useState(false);
//   const [videoSrc, setVideoSrc] = useState(null);

//   // Handle first user interaction to enable autoplay with audio
//   useEffect(() => {
//     const handleFirstInteraction = () => {
//       // setHasUserInteracted(true);

//       // if (videoRef.current) {
//       //   videoRef.current.muted = false;
//       //   videoRef.current
//       //     .play()
//       //     .then(() => {
//       //       setIsVideoPlaying(true);
//       //     })
//       //     .catch((err) => {
//       //       console.warn("Could not play video with audio:", err);
//       //       // Fallback to muted autoplay
//       //       videoRef.current.muted = true;
//       //       videoRef.current
//       //         .play()
//       //         .catch((e) => console.warn("Muted autoplay also failed:", e));
//       //     });
//       // }

//       // Remove listeners after first interaction
//       document.removeEventListener("click", handleFirstInteraction);
//       document.removeEventListener("keydown", handleFirstInteraction);
//       document.removeEventListener("touchstart", handleFirstInteraction);
//       document.removeEventListener("scroll", handleFirstInteraction);
//     };

//     // Add listeners for first user interaction
//     document.addEventListener("click", handleFirstInteraction, {
//       passive: true,
//     });
//     document.addEventListener("keydown", handleFirstInteraction, {
//       passive: true,
//     });
//     document.addEventListener("touchstart", handleFirstInteraction, {
//       passive: true,
//     });
//     document.addEventListener("scroll", handleFirstInteraction, {
//       passive: true,
//     });

//     return () => {
//       document.removeEventListener("click", handleFirstInteraction);
//       document.removeEventListener("keydown", handleFirstInteraction);
//       document.removeEventListener("touchstart", handleFirstInteraction);
//       document.removeEventListener("scroll", handleFirstInteraction);
//     };
//   }, [isVideoPlaying]);

//   // Intersection Observer for play/pause based on visibility
//   useEffect(() => {
//     const bannerEl = document.querySelector(".banner");

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (videoRef.current) {
//           if (entry.isIntersecting) {
//             if (hasUserInteracted) {
//               videoRef.current.muted = false;
//               videoRef.current.currentTime = 0; // restart when banner becomes visible
//               videoRef.current
//                 .play()
//                 .then(() => setIsVideoPlaying(true))
//                 .catch((err) => {
//                   console.warn("Could not play video with audio:", err);
//                   videoRef.current.muted = true;
//                   videoRef.current
//                     .play()
//                     .catch((e) => console.warn("Muted play failed:", e));
//                 });
//             } else {
//               videoRef.current.muted = true;
//               videoRef.current.play().catch((err) => {
//                 console.warn("Muted autoplay failed:", err);
//               });
//             }
//           } else {
//             videoRef.current.pause();
//             setIsVideoPlaying(false);
//           }
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (bannerEl) observer.observe(bannerEl);

//     return () => {
//       if (bannerEl) observer.unobserve(bannerEl);
//     };
//   }, [hasUserInteracted]);

//   // Initial load - try to start with muted autoplay
//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.muted = true;
//       videoRef.current.play().catch((err) => {
//         console.warn("Initial muted autoplay failed:", err);
//       });
//     }
//   }, []);

//   const handleVideoClick = (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     console.log("Video clicked");
//     if (videoRef.current) {
//       setHasUserInteracted(true);
//       videoRef.current.muted = false;
//       videoRef.current.currentTime = 0;
//       const playPromise = videoRef.current.play();
//       if (playPromise !== undefined) {
//         playPromise
//           .then(() => {
//             console.log("Video playing with sound");
//             setIsVideoPlaying(true);
//           })
//           .catch((err) => {
//             console.warn("Play with audio failed:", err);
//           });
//       }
//     }
//   };

//   const {
//     t,
//     i18n: { language },
//   } = useTranslation();

//   const renderStyledText = (text) => {
//     return text.replace(
//       /<color>(.*?)<\/color>/g,
//       '<span style="color: var(--themeColor2);">$1</span>'
//     );
//   };

  
//   useEffect(() => {
//     if(language === "en"){
//       setVideoSrc(TutorialsVidEn);
//     }else{
//       setVideoSrc(TutorialsVidAr);
//     }
//   }, [language, videoSrc]);

//   const secureText = renderStyledText(t("secure_your_data_with_cloud_archive"));

//   const handleSignupButton = () => {
//     // toast.error(t("select_plan_to_continue"))
//     scroller.scrollTo("pricing", {
//       duration: 500,
//       smooth: true,
//     });
//   };

//   // useEffect(() => {
//   //   window.addEventListener("scroll", () => {
//   //     let scrollY = window.scrollY;
//   //     document.documentElement.style.setProperty("--scrollTop", `${scrollY}px`);
//   //   });
//   // }, []);

//   return (
//     <BannerWrapper className="banner" id="home" lang={language}>
//       <Row>
//         <Col className="position-relative">
//           <Box className="header-main">
//             <Container className="banner-container">
//               {/* {language === "en" ? (
//                 <img src={BannerBg} className="banner-bg" alt="" />
//               ) : (
//                 <img src={BannerBgAr} className="banner-bg" alt="" />
//               )} */}

//               <Box className="bannerContentWrapper">
//                 <Box className="banner-content col-md-12 col-lg-6">
//                   <HeadingStyled
//                     className="main-heading caption-sub-heading"
//                     color="var(--text)"
//                     size="36px"
//                     weight="900"
//                     dangerouslySetInnerHTML={{ __html: secureText }}
//                   />
//                   <TextStyled
//                     className=""
//                     color="var(--text)"
//                     size="20px"
//                     lh="1.4"
//                   >
//                     {t("access_organize_protect_docs")}
//                   </TextStyled>
//                   <Box className="whtLngWrapper d-flex align-items-center gap-2 mt-4">
//                     <ContactButton
//                       label={t("get_started_its_free")}
//                       onClick={handleSignupButton}
//                     />
//                     <Link to="/workshop-participants" target="_blank">
//                       <ContactButton
//                         label={t("join_workshop")}
//                         bg="var(--white)"
//                         color="var(--text)"
//                         clName={"signin-btn"}
//                       />
//                     </Link>
//                   </Box>
//                   {/* <TextStyled
//                     size="16px"
//                     color="var(--iconColor)"
//                     className="mt-3"
//                   >
//                     {t("free_forever_no_credit")}
//                   </TextStyled> */}
//                 </Box>
//                 {videoSrc && (
//                   <Box className="position-relative">
//                     <video
//                       ref={videoRef}
//                       autoPlay
//                       muted
//                       playsInline
//                       preload="auto"
//                       loop
//                       className="banner-bg"
//                       onClick={handleVideoClick}
//                       onTouchStart={handleVideoClick}
//                       style={{cursor: "pointer"}}
//                     >
//                       <source src={videoSrc} type="video/mp4" />
//                       Your browser does not support the video tag.
//                     </video>

//                     {/* Optional: Show an unmute button if video is muted */}
//                     {!hasUserInteracted && (
//                       <button
//                         onClick={() => {
//                           setHasUserInteracted(true);
//                           if (videoRef.current) {
//                             videoRef.current.muted = false;
//                             videoRef.current.play().catch((err) => {
//                               console.warn("Could not unmute video:", err);
//                             });
//                           }
//                         }}
//                         className="audio-btn"
//                       >
//                         🔊 {t("click_enable_audio")}
//                       </button>
//                     )}

//                     <TextStyled
//                       className="watch-tutorial-text"
//                       color="var(--text)"
//                       size="20px"
//                       lh="1.4"
//                     >
//                       {t("to_watch_the_tutorial_videos")},{" "}
//                       <Link to="/tutorials" target="_blank" className="click-here">
//                         {t("click_here")}
//                       </Link>
//                     </TextStyled>
//                   </Box>
//                 )}
//               </Box>
//             </Container>
//           </Box>
//         </Col>
//       </Row>
//     </BannerWrapper>
//   );
// };

// export default Banner;


import React, { useEffect, useRef, useState } from "react";
import { AudioOverlay, BannerWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../Styled/Elements";
import { ContactButton } from "../../Styled/CustomElements";
import { BannerBg, BannerBgAr, TutorialsVidAr, TutorialsVidEn } from "../../Styled/AllImages";
import { scroller } from "react-scroll";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const Banner = () => {
  const WEBSITE_URL = process.env.REACT_APP_WEBSITE_BASE_URL;
  const videoRef = useRef(null);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoSrc, setVideoSrc] = useState(null);

  // Handle first user interaction to enable autoplay with audio
  useEffect(() => {
    const handleFirstInteraction = () => {
      // setHasUserInteracted(true);

      // if (videoRef.current) {
      //   videoRef.current.muted = false;
      //   videoRef.current
      //     .play()
      //     .then(() => {
      //       setIsVideoPlaying(true);
      //     })
      //     .catch((err) => {
      //       console.warn("Could not play video with audio:", err);
      //       // Fallback to muted autoplay
      //       videoRef.current.muted = true;
      //       videoRef.current
      //         .play()
      //         .catch((e) => console.warn("Muted autoplay also failed:", e));
      //     });
      // }

      // Remove listeners after first interaction
      document.removeEventListener("click", handleFirstInteraction);
      document.removeEventListener("keydown", handleFirstInteraction);
      document.removeEventListener("touchstart", handleFirstInteraction);
      document.removeEventListener("scroll", handleFirstInteraction);
    };

    // Add listeners for first user interaction
    document.addEventListener("click", handleFirstInteraction, {
      passive: true,
    });
    document.addEventListener("keydown", handleFirstInteraction, {
      passive: true,
    });
    document.addEventListener("touchstart", handleFirstInteraction, {
      passive: true,
    });
    document.addEventListener("scroll", handleFirstInteraction, {
      passive: true,
    });

    return () => {
      document.removeEventListener("click", handleFirstInteraction);
      document.removeEventListener("keydown", handleFirstInteraction);
      document.removeEventListener("touchstart", handleFirstInteraction);
      document.removeEventListener("scroll", handleFirstInteraction);
    };
  }, [isVideoPlaying]);

  // Intersection Observer for play/pause based on visibility
  useEffect(() => {
    const bannerEl = document.querySelector(".banner");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            if (hasUserInteracted) {
              videoRef.current.muted = false;
              videoRef.current.currentTime = 0; // restart when banner becomes visible
              videoRef.current
                .play()
                .then(() => setIsVideoPlaying(true))
                .catch((err) => {
                  console.warn("Could not play video with audio:", err);
                  videoRef.current.muted = true;
                  videoRef.current
                    .play()
                    .catch((e) => console.warn("Muted play failed:", e));
                });
            } else {
              videoRef.current.muted = true;
              videoRef.current.play().catch((err) => {
                console.warn("Muted autoplay failed:", err);
              });
            }
          } else {
            videoRef.current.pause();
            setIsVideoPlaying(false);
          }
        }
      },
      { threshold: 0.3 }
    );

    if (bannerEl) observer.observe(bannerEl);

    return () => {
      if (bannerEl) observer.unobserve(bannerEl);
    };
  }, [hasUserInteracted]);

  // Initial load - try to start with muted autoplay
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch((err) => {
        console.warn("Initial muted autoplay failed:", err);
      });
    }
  }, []);

  const handleVideoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("Video clicked");
    if (videoRef.current) {
      setHasUserInteracted(true);
      videoRef.current.muted = false;
      videoRef.current.currentTime = 0;
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("Video playing with sound");
            setIsVideoPlaying(true);
          })
          .catch((err) => {
            console.warn("Play with audio failed:", err);
          });
      }
    }
  };

  const {
    t,
    i18n: { language },
  } = useTranslation();

  const renderStyledText = (text) => {
    return text.replace(
      /<color>(.*?)<\/color>/g,
      '<span style="color: var(--themeColor2);">$1</span>'
    );
  };

  // Update video source when language changes
  // FIXED: Reset interaction state and pause video when language changes
  useEffect(() => {
    if(language === "en"){
      setVideoSrc(TutorialsVidEn);
    }else{
      setVideoSrc(TutorialsVidAr);
    }
    
    // Reset user interaction when language changes
    setHasUserInteracted(false);
    setIsVideoPlaying(false);
    
    // Pause the current video and mute it
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.muted = true;
      videoRef.current.currentTime = 0;
    }
  }, [language]);

  const secureText = renderStyledText(t("secure_your_data_with_cloud_archive"));

  const handleSignupButton = () => {
    // toast.error(t("select_plan_to_continue"))
    scroller.scrollTo("pricing", {
      duration: 500,
      smooth: true,
    });
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     let scrollY = window.scrollY;
  //     document.documentElement.style.setProperty("--scrollTop", `${scrollY}px`);
  //   });
  // }, []);

  return (
    <BannerWrapper className="banner" id="home" lang={language}>
      <Row>
        <Col className="position-relative">
          <Box className="header-main">
            <Container className="banner-container">
              {/* {language === "en" ? (
                <img src={BannerBg} className="banner-bg" alt="" />
              ) : (
                <img src={BannerBgAr} className="banner-bg" alt="" />
              )} */}

              <Box className="bannerContentWrapper">
                <Box className="banner-content col-md-12 col-lg-6">
                  <HeadingStyled
                    className="main-heading caption-sub-heading"
                    color="var(--text)"
                    size="36px"
                    weight="900"
                    dangerouslySetInnerHTML={{ __html: secureText }}
                  />
                  <TextStyled
                    className=""
                    color="var(--text)"
                    size="20px"
                    lh="1.4"
                  >
                    {t("access_organize_protect_docs")}
                  </TextStyled>
                  <Box className="whtLngWrapper d-flex align-items-center gap-2 mt-4">
                    <ContactButton
                      label={t("get_started_its_free")}
                      onClick={handleSignupButton}
                    />
                    <Link to="/workshop-participants" target="_blank">
                      <ContactButton
                        label={t("join_workshop")}
                        bg="var(--white)"
                        color="var(--text)"
                        clName={"signin-btn"}
                      />
                    </Link>
                  </Box>
                  {/* <TextStyled
                    size="16px"
                    color="var(--iconColor)"
                    className="mt-3"
                  >
                    {t("free_forever_no_credit")}
                  </TextStyled> */}
                </Box>
                {videoSrc && (
                  <Box className="position-relative">
                    <video
                      ref={videoRef}
                      autoPlay
                      muted
                      playsInline
                      preload="auto"
                      loop
                      className="banner-bg"
                      onClick={handleVideoClick}
                      onTouchStart={handleVideoClick}
                      style={{cursor: "pointer"}}
                      key={videoSrc}
                    >
                      <source src={videoSrc} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>

                    {/* Show unmute button if video is muted (user hasn't interacted yet) */}
                    {!hasUserInteracted && (
                      <button
                        onClick={() => {
                          setHasUserInteracted(true);
                          if (videoRef.current) {
                            videoRef.current.muted = false;
                            videoRef.current.play().catch((err) => {
                              console.warn("Could not unmute video:", err);
                            });
                          }
                        }}
                        className="audio-btn"
                      >
                        🔊 {t("click_enable_audio")}
                      </button>
                    )}

                    <TextStyled
                      className="watch-tutorial-text"
                      color="var(--text)"
                      size="20px"
                      lh="1.4"
                    >
                      {t("to_watch_the_tutorial_videos")},{" "}
                      <Link to="/tutorials" target="_blank" className="click-here">
                        {t("click_here")}
                      </Link>
                    </TextStyled>
                  </Box>
                )}
              </Box>
            </Container>
          </Box>
        </Col>
      </Row>
    </BannerWrapper>
  );
};

export default Banner;